import React from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';
export var Component = function Component(_ref) {
  var isFluid = _ref.isFluid,
      length = _ref.length;
  return React.createElement("div", {
    className: classnames('placeholder text', length, {
      fluid: isFluid
    })
  });
};
Component.displayName = 'TextPlaceholder';
Component.defaultProps = {
  isFluid: true,
  length: 'full'
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  isFluid: PropTypes.bool,
  length: PropTypes.oneOf(['short', 'medium', 'long', 'full'])
} : {};